<template>
    <div>
        <div class="padding">
            <van-checkbox-group v-model="clerkSoundIds">
                <van-cell-group>
                    <van-cell
                            v-for="(item, index) in soundList"
                            clickable
                            :key="index"
                            :title="item.name"
                            @click="onCheckboxChange(index)"
                    >
                        <template slot="right-icon">
                            <van-checkbox :name="item.id" ref="soundCheckbox"/>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>

            <div class="text-center margin-tb">
                <van-button type="primary" size="large" @click="submit">保存</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {Cell, CellGroup, Checkbox, CheckboxGroup, Button, Toast, Dialog, Field, Icon} from 'vant';
import {getClerk, updateCategory, updateSound} from '@/api/clerk/clerk'
import {getClerkSoundList} from "@/api/global";

Vue.use(Cell)
    .use(CellGroup)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Button)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Icon)

export default {
    name: 'updateSound',
    data() {
        return {
            categoryList: [],
            clerkCategoryIds: [],
            soundList: [],
            clerkSoundIds: [],
            clerkSex: null,
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            Toast.loading({
                mask: true,
                message: '加载中...'
            })
            // 获取分类列表
            getClerkSoundList().then(res => {
                const data = res.data
                if (data.code == 0) {
                    // 获取店员性别
                    getClerk().then(res => {
                        Toast.clear()
                        const data1 = res.data;
                        if (data1.code == 0) {
                            let clerkSoundIds = []
                            let currentSoundIds = data1.clerk.soundIds ? data1.clerk.soundIds : [];
                            this.soundList = data.soundList.filter(elem => {
                                return elem.sex === data1.clerk.sex || (data1.clerk.sex == null && elem.sex === 1)
                            })
                            // 过滤已删除的音色
                            this.soundList.forEach(elem => {
                                if (currentSoundIds.includes(elem.id)) {
                                    clerkSoundIds.push(elem.id)
                                }
                            })
                            this.clerkSoundIds = clerkSoundIds
                        } else {
                            Dialog.alert({
                                title: '加载' + this.$store.state.label.clerkLabel + '声音失败',
                                message: data1.msg
                            })
                        }
                    })

                } else {
                    Dialog.alert({
                        title: '加载声音失败',
                        message: data.msg
                    })
                }
            })
        },
        onCheckboxChange(index) {
            this.$refs.soundCheckbox[index].toggle()
        },
        submit() {
            Toast.loading({
                mask: true,
                message: '请稍候...'
            })

            updateSound(JSON.stringify(this.clerkSoundIds)).then(res => {
                Toast.clear()
                const data = res.data;
                if (data.code == 0) {
                    Dialog.alert({
                        title: '修改成功'
                    })
                } else {
                    this.loadData()
                    Dialog.alert({
                        title: '修改失败',
                        message: data.msg
                    })
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>


</style>
